import axios from 'axios'
import types from './types'
import { showNotification } from './notifications'

axios.defaults.withCredentials = true

export function loadSiteApplications () {
  return (dispatch) => {
    return dispatch({
      type: types.LOAD_SITE_APPLICATIONS,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/siteapplications`)
    }).then(data => data)
  }
}

export function loadSiteApplication (id) {
  return (dispatch) => {
    return dispatch({
      type: types.LOAD_SITE_APPLICATION,
      payload: axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/siteapplications/${id}`)
    }).then(data => data)
  }
}

export function addSiteApplication (data) {
  return (dispatch) => {
    return dispatch({
      type: types.ADD_SITE_APPLICATION,
      payload: axios.post(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/siteapplications`, data)
    }).then(data => {
      dispatch(showNotification('Application Added!'))
    })
  }
}

export function updateSiteApplication (id, data) {
  return (dispatch) => {
    return dispatch({
      type: types.UPDATE_SITE_APPLICATION,
      payload: axios.put(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/siteapplications/${id}`, data),
      meta: { data }
    }).then(data => {
      dispatch(showNotification('Application Updated!'))
    })
  }
}

export function verifyAuthorization (id) {
  return axios.get(`${process.env.REACT_APP_IDENTITY_API_HOST}/v1/users/me/authorization/${id}`)
}
